var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-warning-triangle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.666,
    viewBox: "0 0 16 14.666"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M294.788 56.044a.419.419 0 0 1 .381.224l5.556 9.764a.44.44 0 0 1 0 .458.422.422 0 0 1-.378.22h-11.115a.419.419 0 0 1-.378-.22.438.438 0 0 1 0-.457l5.556-9.765a.418.418 0 0 1 .38-.224m0-2a2.412 2.412 0 0 0-2.118 1.235l-5.556 9.764a2.451 2.451 0 0 0 2.118 3.667h11.113a2.451 2.451 0 0 0 2.118-3.667l-5.556-9.764a2.413 2.413 0 0 0-2.119-1.235Z",
    transform: "translate(-286.789 -54.044)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 1.5,
    height: 4.752,
    rx: 0.75,
    transform: "translate(7.25 4.581)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 0.75,
    cy: 0.75,
    r: 0.75,
    transform: "translate(7.25 10.166)"
  }))));
};
export { SvgIconWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi13YXJuaW5nLXRyaWFuZ2xlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNC42NjYiIHZpZXdCb3g9IjAgMCAxNiAxNC42NjYiPgogICAgPGcgaWQ9Indhcm5pbmciPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzIxOSIgZGF0YS1uYW1lPSJQYXRoIDIxOSIKICAgICAgICAgICAgICBkPSJNMjk0Ljc4OCw1Ni4wNDRhLjQxOS40MTksMCwwLDEsLjM4MS4yMjRsNS41NTYsOS43NjRhLjQ0LjQ0LDAsMCwxLDAsLjQ1OC40MjIuNDIyLDAsMCwxLS4zNzguMjJIMjg5LjIzMmEuNDE5LjQxOSwwLDAsMS0uMzc4LS4yMi40MzguNDM4LDAsMCwxLDAtLjQ1N2w1LjU1Ni05Ljc2NWEuNDE4LjQxOCwwLDAsMSwuMzgtLjIyNG0wLTJhMi40MTIsMi40MTIsMCwwLDAtMi4xMTgsMS4yMzVsLTUuNTU2LDkuNzY0YTIuNDUxLDIuNDUxLDAsMCwwLDIuMTE4LDMuNjY3aDExLjExM2EyLjQ1MSwyLjQ1MSwwLDAsMCwyLjExOC0zLjY2N2wtNS41NTYtOS43NjRhMi40MTMsMi40MTMsMCwwLDAtMi4xMTktMS4yMzVaIgogICAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODYuNzg5IC01NC4wNDQpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzUwIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA1MCIgd2lkdGg9IjEuNSIgaGVpZ2h0PSI0Ljc1MiIgcng9IjAuNzUiCiAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4yNSA0LjU4MSkiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNTgiIGRhdGEtbmFtZT0iRWxsaXBzZSA1OCIgY3g9IjAuNzUiIGN5PSIwLjc1IiByPSIwLjc1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjI1IDEwLjE2NikiCiAgICAgICAgICAgICAgICBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgIDwvZz4KPC9zdmc+Cg==";